import { useState, useCallback } from "react";
import axios from "axios";
// Note: We removed the local upsAPI import since we are using a public REST API now

function useZipCodeValidation() {
  const [zips, setZips] = useState({});

  let cancel;

  const { CancelToken } = axios;

  const zipCodeValidation = useCallback(
    async (value) => {
      if (!value) {
        return undefined;
      }

      if (value.length !== 5) {
        return "Zip code must be a 5 digit number";
      }

      if (zips[value] !== undefined) {
        return zips[value] ? zips[value] : undefined;
      }

      try {
        let result;

        if (cancel !== undefined) {
          cancel();
        }

        // Fetch the Zip Code data from Zippopotam.us
        const { data } = await axios.get(
          `https://api.zippopotam.us/us/${value}`,
          {
            cancelToken: new CancelToken(function executor(c) {
              cancel = c;
            }),
          }
        );

        // The API returns a JSON object. We grab the state abbreviation from the first place match.
        const stateAbbrev = data.places[0]["state abbreviation"];

        // Return error if ZIP is Hawaiian...
        if (stateAbbrev === "HI") {
          result = "Sorry, we do not have any agents in Hawaii";
        }
        // Return error if ZIP is Alaskan...
        else if (stateAbbrev === "AK") {
          result = "Sorry, we do not have any agents in Alaska";
        }

        setZips((prev) => ({
          ...prev,
          [value]: result || false,
        }));

        return result;
      } catch (e) {
        // If the request is cancelled because the user kept typing, ignore it
        if (axios.isCancel(e)) {
          return undefined;
        }

        // Zippopotam.us returns a 404 Not Found error if the zip code doesn't exist
        if (e.response && e.response.status === 404) {
          const errorMsg = "Please enter a valid zip code.";
          setZips((prev) => ({
            ...prev,
            [value]: errorMsg,
          }));
          return errorMsg;
        }

        // eslint-disable-next-line no-console
        console.error(e);
        return undefined;
      }
    },
    [zips]
  );

  return async (values) => {
    const errors = {};
    if (values.moving_from) {
      errors.moving_from = await zipCodeValidation(values.moving_from);
    }
    if (values.moving_to) {
      errors.moving_to = await zipCodeValidation(values.moving_to);
    }
    return errors;
  };
}

export default useZipCodeValidation;
